import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useEffect } from 'react';
import LoginForm from '../components/auth/LoginForm';

const LoginPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    // Redirect if already logged in
    if (user) {
      navigate('/creator');
    }
  }, [user, navigate]);

  const handleLoginSuccess = () => {
    navigate('/creator');
  };

  return <LoginForm onSuccess={handleLoginSuccess} />;
};

export default LoginPage;